import React from 'react';
import PropTypes from 'prop-types';
import sha256 from 'crypto-js/hmac-sha256';
import APLabelWithText from '../../common/APLabelWithText';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './ConfirmAPIKeyModal.css';
var baseClasses = getBEMClasses('confirm-api-key');
var ConfirmAPIKeyModal = function ConfirmAPIKeyModal(props, context) {
  var Permissions = props.item.Permissions;
  var nonce = window.crypto.getRandomValues(new Uint32Array(1)).toString();
  var userId = props.userId,
    _props$item = props.item,
    APIKey = _props$item.APIKey,
    APISecret = _props$item.APISecret;
  return React.createElement('div', {
    className: baseClasses()
  }, React.createElement('div', {
    className: baseClasses('key-info-container')
  }, React.createElement(APLabelWithText, {
    label: context.t('Permissions'),
    text: Permissions.join(', '),
    customClass: baseClasses()
  }), React.createElement(APLabelWithText, {
    label: context.t('Key'),
    text: APIKey,
    customClass: baseClasses()
  }), APISecret && React.createElement(React.Fragment, null, React.createElement(APLabelWithText, {
    label: context.t('Secret'),
    text: APISecret,
    customClass: baseClasses()
  }))), APISecret && React.createElement(React.Fragment, null, React.createElement('div', {
    className: baseClasses('authenticate-user')
  }, React.createElement('p', null, context.t('Call {a} with the following to login:', {
    a: React.createElement('code', null, 'AuthenticateUser')
  })), React.createElement('pre', null, JSON.stringify({
    APIKey: APIKey,
    Signature: sha256('' + nonce + userId + APIKey, APISecret).toString(),
    UserId: userId.toString(),
    Nonce: nonce
  }, null, 2)), React.createElement('p', null, context.t('To generate your own signature with a different nonce, {hmacSha256} encode your nonce, user ID, and API key, in the format {messageFormat} using the secret as your key.', {
    hmacSha256: React.createElement('a', {
      href: 'https://codebeautify.org/hmac-generator',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, 'HMAC-Sha256'),
    messageFormat: React.createElement('code', null, 'NonceUserIdAPIKey')
  })))));
};
ConfirmAPIKeyModal.contextTypes = {
  t: PropTypes.func.isRequired
};
ConfirmAPIKeyModal.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  onRemove: PropTypes.func
};
ConfirmAPIKeyModal.defaultProps = {
  index: 0
};
export default ConfirmAPIKeyModal;